<template>
    <InformeCard @click="draw" title="Compras por hora" v-if="totalHorasVentas" id="compras_por_hora" name="compras_por_hora" collapsable="true">
        <h4 class="text-center">Compras por hora</h4>
        <GChart
            type="ColumnChart"
            :resizeDebounce="100"
            :data="totalHorasVentas"
            :options="chartOptions"
            ref="googleChart"
        />
    </InformeCard>
</template>

<script>
    import InformeCard from "../InformeCard";

    export default {
        props: ['event_id'],
        data() {
            return {
                totalHorasVentas: [],
                chartOptions: {
                    height: 250,
                    legend: { position: "none" },
                    chartArea:{ width: 750 }
                }
            }
        },
        methods: {
            getHorasVentas() {
                const params = {
                    filters : {},
                    evento_id: this.event_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.informe.compras-por-hora'), params).then(res => {
                    this.totalHorasVentas = res.data;

                    this.$emit('totalHorasVentas', this.totalHorasVentas);
                });
            },
            draw() {
                setTimeout(() => {
                    this.$refs.googleChart.drawChart()
                }, 50)
            }
        },
        created() {
            this.getHorasVentas();
        },
        components: {
            InformeCard
        }
    }

</script>